import { reactify } from '@zeiss/zui-react';
export const ZuiIconRmsLamellaThinningCompositeShape2ndIteration = reactify('zui-icon-rms-lamella-thinning-composite-shape-2nd-iteration');
